module.exports = __webpack_public_path__ + "img/modal_notes.7f3b0c62.png";